<template>
	<div>
		<MaintenancePage v-if="isMaintenanceActive" :active="true" />
		<NotFoundPage v-else-if="statusCode === 404" />

		<Container v-else narrow class="py-5 text-center">
			<img
				src="/illu_error.svg"
				class="mx-auto mb-5 d-block"
				style="width: 10rem;"
			/>

			<div>
				<div class="prehead text-danger">Error {{ statusCode }}</div>
				<h1 class="mb-2">{{ $t(`error.${statusCode}.title`) }}</h1>
				<pre
					class="my-2 lead d-inline-block text-danger text-wrap mw-100"
					>{{ message }}</pre
				>
				<div v-html="$t('error.informed')"></div>

				<Button
					type="tertiary"
					icon="comment-lines"
					class="mt-4 mr-2"
					@click="showReportDialog()"
				>
					{{ $t('error.feedback') }}
				</Button>
				<Button
					type="tertiary"
					icon="sync-alt"
					class="mt-4 mr-2"
					@click="refreshPage()"
				>
					{{ $t('crud.reload') }}
				</Button>
				<a
					:href="
						`mailto:tobija.fischer@apropos.jobs?subject=${$t(
							`error.${statusCode}.title`
						)} auf ${$route.fullPath}`
					"
					hidden
				>
					<Button type="link" class="mt-4">
						{{ $t('link.contact-support') }}
					</Button>
				</a>

				<a href="/auth/logout">
					<Button type="tertiary" class="mt-4">
						{{ $t('auth.signing-out-title') }}
					</Button>
				</a>
			</div>
		</Container>
	</div>
</template>

<script>
import * as Sentry from '@sentry/browser'
import MaintenancePage from '~/components/Maintenance/MaintenancePage'
import NotFoundPage from '~/components/Errors/NotFoundPage'
import { checkMaintenanceHealth } from '~/plugins/maintenance.client'
import Container from '~/components/ui/layout/Container'
import Button from '~/components/ui/common/Button'

export default {
	name: 'NuxtError',
	components: {
		MaintenancePage,
		NotFoundPage,
		Container,
		Button
	},
	props: ['error'],
	layout({ app }) {
		return app.nuxt.err?.statusCode === 404 ? 'system' : 'guest'
	},
	computed: {
		statusCode() {
			return (this.error && this.error.statusCode) || 500
		},
		message() {
			return this.error.message || '<%= messages.client_error %>'
		},
		isMaintenanceActive() {
			return Boolean(this.$store?.state?.maintenance?.active)
		}
	},
	head() {
		return {
			title: this.message
		}
	},
	mounted() {
		if (
			this.statusCode === 500 &&
			this.error.message.includes('Loading chunk ') &&
			this.error.message.includes(' failed.') &&
			window.location.hash !== '#retry'
		) {
			// the chunk might no longer be available due to a recent redeployment of the page
			// mark the page to don't trigger reload infinitely
			window.location.hash = '#retry'
			window.location.reload(true)
		}

		this.checkMaintenance()
	},
	methods: {
		async checkMaintenance() {
			if (this.isMaintenanceActive || this.statusCode < 500) {
				return
			}

			await checkMaintenanceHealth({
				$axios: this.$axios,
				store: this.$store,
				route: this.$route,
				apiVanityUrl:
					(this.$config && this.$config.apiVanityUrl) || ''
			})
		},

		refreshPage() {
			window.location.reload()
		},

		showReportDialog() {
			Sentry.showReportDialog({
				lang: this.$store.state.locale ?? 'de',
				user: {
					email: this.$user.email,
					name: this.$user.fullName
				}
			})
		}
	}
}
</script>
